import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { LogoutOutlined } from '@ant-design/icons';
import style from './shell.module.scss';
import { useAuth } from '../context/useAuth';
import { useChatNotifications } from '../features/chat/context/useChatNotifications';
import { useRequestNotifications } from '../features/therapyOccurrenceRequests/context/useRequestNotifications';
import { navGroups } from './navConfig';

const Sidebar = ({ collapsed }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const { totalUnread } = useChatNotifications();
  const { unseenCount } = useRequestNotifications();

  // Brojevi na stavkama navigacije: neprocitane poruke i novi zahtevi.
  const badgeCounts = {
    '/poruke': totalUnread,
    '/zahtevi': unseenCount,
  };

  const activePath = location.pathname;
  const isActive = (href) =>
    activePath === href || activePath.startsWith(`${href}/`);

  return (
    <aside
      className={`sidebar ${style.sidebar} ${collapsed ? style.collapsed : ''}`}
    >
      <div className={style.brand}>
        <Link to="/terapije" className={style.brandLogoLink}>
          <img className={style.brandLogo} src="/logo.svg" alt="Galena" />
        </Link>
        {!collapsed && <span className={style.brandName}>Galena Park</span>}
      </div>

      <nav className={style.nav}>
        {navGroups.map((group) => {
          const items = group.items.filter((link) =>
            typeof link.visible === 'function' ? link.visible(user) : true
          );
          if (items.length === 0) return null;

          return (
            <div key={group.title} className={style.navGroup}>
              {!collapsed && (
                <div className={style.navGroupLabel}>{group.title}</div>
              )}
              {items.map((link) => {
                const Icon = link.icon;
                const active = isActive(link.href);
                const badgeCount = badgeCounts[link.href] || 0;
                const showBadge = badgeCount > 0;
                const badgeText = badgeCount > 99 ? '99+' : badgeCount;

                return (
                  <Link
                    key={link.href}
                    to={link.href}
                    title={collapsed ? link.label : undefined}
                    className={`${style.navItem} ${active ? style.navItemActive : ''}`}
                  >
                    <span className={style.navIcon}>
                      <Icon />
                    </span>
                    {!collapsed && (
                      <span className={style.navLabel}>{link.label}</span>
                    )}
                    {showBadge &&
                      (collapsed ? (
                        <span className={`${style.badge} ${style.badgeDot}`}>
                          {badgeText}
                        </span>
                      ) : (
                        <span className={style.badge}>{badgeText}</span>
                      ))}
                  </Link>
                );
              })}
            </div>
          );
        })}
      </nav>

      <div className={style.footer}>
        <button
          type="button"
          className={style.logoutBtn}
          onClick={() => logout()}
          title={collapsed ? 'Odjavi se' : undefined}
        >
          <span className={style.navIcon}>
            <LogoutOutlined />
          </span>
          {!collapsed && <span className={style.logoutLabel}>Odjavi se</span>}
        </button>
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  collapsed: PropTypes.bool,
};

export default Sidebar;
